import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useHookEmployeePosition } from "../../../hooks/useHookEmployeePosition";
import { EmployeePositionCreate } from "./EmployeePositionCreate";
import { BtnDefault } from "../../../components/buttons/BtnDefault";
import { FaEdit, FaTrash } from "react-icons/fa";

export const SelectEmployeePosition = ({value, setValue}) => {
    const [open, setOpen] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [openModalCreate, setOpenModalCreate] = useState(false);
    const { data, loading, error, refreshData } = useHookEmployeePosition();
    return (
        <>
            <div className="relative">
                <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-3 py-2 mt-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
                <span>
                    {selectedData ? selectedData.name : "Pilih Posisi / Jabatan"}
                </span>
                    <FiChevronDown className="text-gray-400 text-lg sm:text-xl" />
                </button>
                <div className={`absolute w-full bg-white rounded-md shadow-lg z-10 overflow-hidden transition-all duration-500 ease-in-out flex flex-col gap-3 p-3
                        ${open ? "scale-100" : "scale-0"}
                        transition-all duration-500 ease-in-out
                    `}>
                    {
                        data && data.length > 0 && data.map((item, index) => (
                            <button 
                            key={index} 
                            onClick={() => {
                                setValue(item.id);
                                setSelectedData(item);
                                setOpen(false);
                            }}
                            className="flex items-center justify-between px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100 transition-colors"
                            >
                                <div>
                                    <span>{item.name}</span>
                                    <span>{item.phone_number}</span>
                                </div>
                                <div className="flex items-center gap-2">
                                <button type="button" className="text-yellow-500 hover:text-yellow-600 transition-colors">
                                    <FaEdit/>
                                </button>
                                <button type="button" className="text-red-500 hover:text-red-600 transition-colors">
                                    <FaTrash/>
                                </button>
                                </div>
                            </button>
                        ))
                    }
                    <BtnDefault type="button" onClick={() => setOpenModalCreate(true)} className="w-full flex items-center justify-center text-center">
                        Tambah Data
                    </BtnDefault>
                </div>
            </div>


            {/* Create Nas */}
            <EmployeePositionCreate
                open={openModalCreate}
                setOpen={setOpenModalCreate}
                refreshData={refreshData}

            // setAlertMessage={setAlertMessage}
            // setAlertType={setAlertType}
            // setShowAlert={setOpenAlert}
            />
        </>
    )
}